<template>
  <v-card class="v-card--wizard" elevation="12" max-width="440">
    <v-tabs ref="tabs" v-model="internalValue" background-color="grey lighten-5" color="white" grow slider-size="70">
      <v-tabs-slider class="mt-1" color="primary" />

      <v-tab
        v-for="(item, i) in items"
        :key="i"
        :ripple="false"
        :disabled="
          !availableSteps.includes(i) || (i == 1 && valueSecondTab == 'disabled') || (i == 0 && valueSecondTab == 'active')
        "
      >
        {{ item }}
      </v-tab>
    </v-tabs>
    <div class="my-6" />
    <v-card-text>
      <v-tabs-items v-model="internalValue">
        <slot />
        <v-row v-if="internalValue === 0" class="px-10">
          <v-col cols="12" class="py-0">
            <v-btn
              color="primary"
              style="width: 100% !important"
              :loading="loading"
              :disabled="!availableSteps.includes(internalValue + 1)"
              @click="$emit('click:next')"
            >
              Próximo
            </v-btn>
          </v-col>
        </v-row>
      </v-tabs-items>
    </v-card-text>
    <v-card-actions class="d-flex pa-4 pb-4">
      <v-btn
        v-if="internalValue !== 0"
        :disabled="internalValue === 0 || internalValue == 1"
        class="flex-shrink-1 white--text"
        color="grey darken-2"
        outlined
        min-width="125"
        @click="$emit('click:prev')"
      >
        Anterior
      </v-btn>
      <v-btn v-if="internalValue === 0" color="primary" class="flex-shrink-1" min-width="125" text @click="$emit('click:reset')">
        Esqueci a senha
        <v-icon dark class="pl-0">mdi-arrow-right</v-icon>
      </v-btn>
      <v-spacer class="flex-shrink-1" />

      <!-- <v-btn
        v-if="internalValue === 0"
        color="primary"
        class="flex-shrink-1"
        min-width="125"
        text
        @click="$emit('click:request')"
      >
        Solicitar Acesso
        <v-icon
          dark
          class="pl-0"
        >
          mdi-arrow-right
        </v-icon>
      </v-btn> -->

      <v-btn
        v-if="internalValue !== 0"
        color="primary"
        class="flex-shrink-1"
        min-width="100"
        :loading="loading"
        :disabled="!availableSteps.includes(internalValue + 1) || disabledBtnLogar"
        @click="$emit('click:next')"
      >
        Entrar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import Proxyable from 'vuetify/lib/mixins/proxyable';

  export default {
    name: 'BaseLoginMaterialWizard',
    mixins: [Proxyable],
    props: {
      availableSteps: {
        type: Array,
        default: () => []
      },
      items: {
        type: Array,
        default: () => []
      },
      disabledBtnLogar: {
        type: Boolean,
        default: false,
        required: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    emits: ['click:prev', 'click:next', 'click:reset'],
    data() {
      return {
        valueSecondTab: 'disabled'
      };
    },
    methods: {
      activateSecondTab() {
        this.valueSecondTab = 'active';
      }
    }
  };
</script>

<style lang="sass">
  .v-card--wizard
    overflow: visible

    .v-tabs-bar
      height: 56px
      padding: 0 0px

    .v-tabs-slider-wrapper
      overflow: visible

    .v-tabs-slider
      border-radius: 4px

    .v-tabs-slider-wrapper
      contain: initial
      z-index: 0
</style>
